import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -10","key":"svg-0"}]]

const IconCrop54 = createReactComponent('outline', 'crop-5-4', 'Crop54', __iconNode);

export default IconCrop54;